import { MessageDescriptor } from 'react-intl';
import { AccountAdminSettingEntity } from '../common/account-admin-setting.entity';
import { BaseAccountAdminSettingViewModel } from '../common/base-account-admin-setting-form.viewmodel';
import { SEGREGATED_DATA_ENCRYPTION_UPDATED_TEXT } from '../account-admin.text';

class SegregatedDataEncryptionFormVM extends BaseAccountAdminSettingViewModel {
    constructor(
        protected readonly entity: AccountAdminSettingEntity,
    ) {
        super(entity);
    }

    public get notificationMessage(): MessageDescriptor {
        return SEGREGATED_DATA_ENCRYPTION_UPDATED_TEXT;
    }

    public async apiCall(): Promise<void> {
        await this.accountAdminDAO.updateSegregatedDataEncryptionData({
            ...this.entity.getCommonAPIPayload(),
            segregatedDataEncryptionEnabled: this.entity.enabled,
        });
    }
}

export { SegregatedDataEncryptionFormVM };